import { render, staticRenderFns } from "./Taobao-expend.vue?vue&type=template&id=a6ba882e&"
import script from "./Taobao-expend.vue?vue&type=script&lang=js&"
export * from "./Taobao-expend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports